import cn from 'classnames';
import type { ComponentChildren, JSX } from 'preact';
import type { IconType } from '../../types/icons';
import type { HTMLAttributes } from '../../types';
import type { BackgroundVariant, ColorVariant } from '../../types/common';

interface PassedProps {
  as?: keyof JSX.IntrinsicElements;
  children?: ComponentChildren;
  display?: 'block' | 'inline';
  icon: IconType;
  iconBackground?: BackgroundVariant;
  iconColor?: ColorVariant;
  iconPosition?: 'before' | 'after';
}

type Props = PassedProps & HTMLAttributes<HTMLElement>;

export default function Icon({
  as: Element = 'p',
  display = 'block',
  icon,
  iconBackground,
  iconColor,
  iconPosition = 'before',
  className,
  children,
  ...props
}: Props) {
  const classList = cn(className, {
    ['icon-after']: iconPosition === 'after',
    [`display-${display}`]: display !== 'block',
  });

  return (
    /* @ts-ignore-error */
    <Element
      {...props}
      className={classList}
      data-icon={icon}
      style={{
        '--icon-background': iconBackground ? `var(--${iconBackground})` : undefined,
        '--icon-color': iconColor ? `var(--${iconColor})` : undefined,
      }}
    >
      {children}
    </Element>
  );
}

export function Badge({ className, ...props }: Props & { 'aria-label': string }) {
  return <Icon {...props} className={cn('badge', className)} />;
}

export function AttachmentTag({ className, ...props }: Props) {
  return <Icon {...props} className={cn('attachment-tag', className)} />;
}
